import logo from './logo.svg';
import './App.css';
import YearPicker from './components/YearPicker.js';
import ImgContainer from './components/ImgContainer.js';

function App() {
  return (
    <div className="App">
      <div className="site-banner">
        <img
          src="img/india-elects-banner.png"
          alt="India Elects banner"
          className="site-banner__image"
        />
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <div>
            <YearPicker startYear={2000} endYear={new Date().getFullYear()} />
            <ImgContainer path="india-elects-banner.png" />
        </div>
        <div>
          <YearPicker startYear={2000} endYear={new Date().getFullYear()} />
          <ImgContainer path="india-elects-banner.png" />
         </div>
      </div>
    </div>
  );
}

export default App;
